import mockAxios, { AxiosResponse } from 'axios';

import { IFileLoaderServiceMock } from './fileloader.mock.types';

export const mockFileLoaderService = (): IFileLoaderServiceMock => ({
  downloadFile: jest.fn()
});

export const mockFileLoaderAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
